import axios from "axios";

export default function SubscriptionCancelService() {

  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/subscription_cancel",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
